import appConfig from '../../../config';

function shouldDisplayForPath(depositor, pathname) {
  if (depositor) {
    switch (pathname) {
      case '/dashboard': // falls through
      case '/documents': // falls through
      case '/clients': // falls through
      case '/clients/list': return true;
      default: return false;
    }
  }
  switch (pathname) {
    case '/dashboard': // falls through
    case '/subcontractors': // falls through
    case '/subcontractors/list': // falls through
    case '/projects': return true;
    default: return false;
  }
}

function shouldDisplay(bdrServiceAuthorized, organisation, pathname) {
  if (
    !appConfig?.featureFlags?.showAccessBdrButton ||
    !organisation.enabled ||
    !bdrServiceAuthorized
  ) {
    return false;
  }

  return shouldDisplayForPath(organisation.depositor, pathname);
}

export default {
  shouldDisplay
};
